<template>
  <div class="marker-info">
    <div v-if="markerInfoData.type === 'memo'">
      <div class="marker-info-large-bottom">
        <div class="marker-info-description">
          <i-tag-list
            class="marker-info-category"
            :tags="[subtitleAndDescription.subtitle]"
          />
          <!-- v-html-safe come from vue-html-secure -->
          <pre
            v-html-safe="subtitleAndDescription.description"
            class="pre-custom"
          />
        </div>
      </div>
    </div>
    <div
      v-if="markerInfoData.type === 'tag'"
      class="marker-info-tag"
    >
      <div class="marker-info-large-top">
        <div :class="['marker-info-large-right', {'has-image': markerInfoData.photo}]">
          <h4 class="marker-info-text marker-info-name">
            <span
              v-html-safe="markerInfoData.nameMulti[lang] || markerInfoData.name"
              class="text-inner"
            />
          </h4>
          <template v-if="currentCollectionName">
            <h5 class="marker-info-text marker-info-name">
              <span
                v-html-safe="currentCollectionName"
                class="text-inner"
              />
            </h5>
            <h4 class="marker-info-text marker-info-price">
              <select
                name="price-type-select"
                class="marker-info-select"
                :value="currentPriceType.id"
                @change="updatePriceType"
              >
                <option
                  v-for="price in availablePriceType"
                  :key="price.id"
                  :value="price.id"
                >
                  {{ price.currency_code }}
                </option>
              </select>
              <span class="text-inner">
                {{ wholesalePrice }}
              </span>
            </h4>
          </template>
          <template v-else>
            <template v-if="!isJoorActionTag(markerInfoData)">
              <h4
                v-show="markerInfoData.price"
                class="marker-info-text marker-info-price"
              >
                <span class="text-inner">
                  {{ markerInfoData.priceMulti[lang] || markerInfoData.price }}
                </span>
              </h4>
            </template>
          </template>
          <i-tag-list
            class="marker-info-category"
            :tags="[subtitleAndDescription.subtitle]"
          />
          <template v-if="isJoorActionTag(markerInfoData) && isInJoorPlatform || !isJoorActionTag(markerInfoData)">
            <div
              v-show="markerInfoData.action"
              class="marker-info-text marker-info-action"
            >
              <button
                class="marker-info-button"
                @click="clickTagAction"
              >
                {{ getActionMutate(markerInfoData) }}
              </button>
            </div>
          </template>
          <div class="marker-info-description marker-info-desktop">
            <!-- v-html-safe come from vue-html-secure -->
            <pre
              v-html-safe="subtitleAndDescription.description"
              class="pre-custom"
            />
          </div>
        </div>
        <div
          v-if="markerImage"
          class="marker-info-large-left"
        >
          <i-scale-image
            :key="displayImageIndex/* force re render to compute container height width*/"
            class="scale-image"
            :src="markerImage"
            :alt="markerInfoData.name"
            :scale.sync="imageScale"
          />
          <i-slider
            v-model="imageScale"
            direction="vertical"
            :min="1"
            :max="5"
            :step="0.1"
            @change="onSliderChange"
          />
          <button
            v-if="isArViewButtonVisible"
            class="arview-button"
            @mouseenter="showViewIn3DTooltip"
            @mouseleave="hideViewIn3DTooltip"
            @click="showArView"
          >
            <img :src="require('@/assets/images/armaker/arview-cube.png')">
            <div
              v-if="isViewIn3DTooltipVisible"
              class="tooltip"
            >
              {{ $t('viewIn3D') }}
            </div>
          </button>
          <template v-if="markerInfoData.images.length > 1">
            <button
              class="arrow left"
              @click="displayImageIndex -= 1; imageScale = 1"
            >
              <i class="isif isif-arrow-left" />
            </button>
            <button
              class="arrow right"
              @click="displayImageIndex += 1; imageScale = 1"
            >
              <i class="isif isif-arrow-right" />
            </button>
          </template>
        </div>
        <div class="marker-info-description marker-info-mobile">
          <!-- v-html-safe come from vue-html-secure -->
          <pre
            v-html-safe="subtitleAndDescription.description"
            class="pre-custom"
          />
        </div>
      </div>
    </div>
    <div v-if="markerInfoData.type === 'gallery'">
      <div class="gallery-wrapper">
        <h4
          v-if="isGalleryImageReady"
          v-html-safe="markerInfoData.nameMulti[lang] || markerInfoData.name"
          class="br-title padding-x-30"
        />
        <i-tag-list
          class="marker-info-category"
          :tags="[subtitleAndDescription.subtitle]"
        />
        <div
          class="gallery-container"
          @mousemove="handleDragging"
          @touchmove="handleDragging"
          @mousedown="dragStart"
          @touchstart="dragStart"
          @dragstart="dragStart"
          @mouseup="isDragging = false"
          @touchend="isDragging = false"
        >
          <img
            ref="gallery"
            class="gallery-image"
            :src="markerInfoData.photo"
            :alt="markerInfoData.name"
            :style="{ transform: `scale(${scale}) translate(${interactX}px, ${interactY}px)` }"
            @contextmenu.prevent="rightClickBlock"
            @load="onGalleryImageLoad"
          >
        </div>
        <div class="scale-btns">
          <button
            :disabled="scale === maxScale"
            @click="setScale(2)"
          >
            {{ $t('scaleUp') }}
          </button>
          <button
            :disabled="scale === minScale"
            @click="setScale(0.5)"
          >
            {{ $t('scaleDown') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="markerInfoData.type === 'multitag'"
      class="h-100"
    >
      <multitag
        :multitag="markerInfoData"
        :get-action-mutate="getActionMutate"
        :is-joor-action-tag="isJoorActionTag"
        :custom-setting="customSetting"
        @close="closeMarkerInfo"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Message, Loading } from 'element-ui'
import cloneDeep from 'lodash/cloneDeep'
import has from 'lodash/has'
import toString from 'lodash/toString'
import ITagList from '@/components/ITagList'
import Multitag from './Multitag/Multitag'
import IScaleImage from '@/components/IScaleImage'
import ISlider from '@/components/ISlider'
import gaEvents from '@/api/ga-events'
import { isMobile } from '@/api/utils'
import { AR_VIEW_ENABLE_MARKERS } from '@/api/armaker'
import { extractSubtitleAndDescription } from '@/utils/markerSubtitle'

export default {
  name: 'MarkerInfo',
  components: {
    ITagList,
    Multitag,
    IScaleImage,
    ISlider
  },
  data () {
    return {
      isGalleryImageReady: false,
      isGalleryImageHover: false,
      customGalleryImageMaxWidth: '',
      scale: 1,
      interactX: 0,
      interactY: 0,
      firstX: 0,
      firstY: 0,
      maxScale: 16,
      minScale: 1,
      isDragging: false,
      imageInfo: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        originalWidth: 0,
        originalHeight: 0
      },
      lang: this.$i18n.locale,
      displayImageIndex: 0,
      imageScale: 1,
      isViewIn3DTooltipVisible: false,
      viewIn3DTooltipTimer: null,
      hideViewIn3DTooltipTimer: null
    }
  },

  computed: {
    ...mapGetters([
      'currentPanorama',
      'markerInfoData',
      'isMarkerInfoActive',
      'customSetting'
    ]),

    ...mapGetters('joor', [
      'priceType',
      'products',
      'skus',
      'currentPriceType',
      'accessToken',
      'orders',
      'collections',
      'isInJoorPlatform'
    ]),

    subtitleAndDescription () {
      return extractSubtitleAndDescription(this.markerInfoData.descriptionMulti[this.lang] || this.markerInfoData.description)
    },

    markerImage () {
      if (this.markerInfoData.type === 'tag' && this.markerInfoData.images.length) {
        return this.markerInfoData.images[this.mathMod(this.displayImageIndex, this.markerInfoData.images.length)]
      }
      return ''
    },

    imagePositionLimit () {
      const { originalWidth, originalHeight, width, height } = this.imageInfo
      return {
        limitWidth: (width - originalWidth) / 2,
        limitHeight: (height - originalHeight) / 2
      }
    },

    availablePriceType () {
      if (this.isJoorActionTag(this.markerInfoData) &&
      this.priceType.length > 0 &&
      this.products[this.markerInfoData.customAttribute.joorProductId]) {
        const skuIds = this.products[this.markerInfoData.customAttribute.joorProductId]
        const priceBySkuIds = skuIds.reduce((priceBySkuIds, skuId) => {
          if (this.skus[skuId]) {
            priceBySkuIds.push(...this.skus[skuId])
          }
          return priceBySkuIds
        }, [])
        const availablePriceType = priceBySkuIds
          .filter(price => this.priceType.some(priceType => priceType.id === price.price_type.id))
          .map(price => {
            const clonePrice = cloneDeep(price)
            clonePrice.price_type.skus = {
              [clonePrice.sku_id]: {
                skuId: clonePrice.sku_id,
                wholesale_value: clonePrice.wholesale_value,
                retail_value: clonePrice.retail_value
              }
            }
            return clonePrice.price_type
          })
          .reduce((priceTypes, currentPrice) => {
            const targetPriceType = priceTypes.find(priceType => priceType.id === currentPrice.id)
            if (targetPriceType) {
              targetPriceType.skus = Object.assign(targetPriceType.skus, currentPrice.skus)
            } else {
              priceTypes.push(currentPrice)
            }
            return priceTypes
          }, [])
        return availablePriceType
      }
      return []
    },

    wholesalePrice () {
      if (this.currentPriceType.id) {
        const currentSkuIds = this.products[this.markerInfoData.customAttribute.joorProductId]
        const targetSkuId = currentSkuIds ? currentSkuIds.find(skuId => this.currentPriceType.skus[skuId]) : ''
        if (targetSkuId) {
          return this.currentPriceType.skus[targetSkuId].wholesale_value
        }
      }
      return ''
    },

    currentCollectionName () {
      if (this.isJoorActionTag(this.markerInfoData) && this.isInJoorPlatform) {
        const currentCollection = this.collections.find(collection => collection.id === this.markerInfoData.customAttribute.joorCollectionId)
        return currentCollection ? currentCollection.name : ''
      }
      return ''
    },
    isArViewButtonVisible () {
      const arViewEnabled = this.customSetting.arView
      const isArViewEnableMarker = AR_VIEW_ENABLE_MARKERS.includes(this.markerInfoData.type)
      const arViewAction = this.markerInfoData.arView ? this.markerInfoData.arView.action : null
      const arViewUrl = arViewAction ? arViewAction.url : ''
      return arViewEnabled && isArViewEnableMarker && arViewUrl
    }
  },

  watch: {
    currentPanorama: {
      handler () {
        this.setMarkerInfoData({})
        this.closeMarkerInfo()
      },
      deep: true
    },

    isMarkerInfoActive: {
      handler (newVal) {
        if (!newVal) {
          this.displayImageIndex = 0
          this.isGalleryImageReady = false
          this.scale = 1
          this.interactX = 0
          this.interactY = 0
          this.imageScale = 1
          this.setMarkerInfoData({})
          this.resetCurrentPriceType()
          this.closeArViewPopup()
        } else if (this.isInJoorPlatform) {
          this.fetchJoorProductProcess()
        }
      },
      deep: true
    },
    isArViewButtonVisible: {
      handler (val) {
        if (val) {
          this.viewIn3DTooltipTimer = setTimeout(() => {
            this.isViewIn3DTooltipVisible = true
            this.hideViewIn3DTooltipTimer = setTimeout(() => {
              this.isViewIn3DTooltipVisible = false
            }, 5000)
          }, 3000)
        } else {
          this.isViewIn3DTooltipVisible = false
          this.clearViewIn3DTooltipTimer()
        }
      }
    }
  },

  mounted () {
    document.addEventListener('touchstart', (event) => {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    }, { passive: false })
  },

  methods: {
    ...mapActions([
      'closeMarkerInfo',
      'setMarkerInfoData',
      'setPopupUrl',
      'setPopupSizeConfig',
      'showPopup'
    ]),

    ...mapActions('joor', [
      'setCurrentPriceType',
      'getProductProcess',
      'addToOrderProcess',
      'resetCurrentPriceType'
    ]),
    ...mapActions('arview', [
      'showArViewPopup',
      'closeArViewPopup',
      'setArViewPopupAction',
      'setArViewPopupSize'
    ]),

    onSliderChange () {
      gaEvents.sendEvent('Marker', 'ZoomBySlider', this.markerInfoData.objectId)
    },

    dragStart (e) {
      e.preventDefault()

      const target = e.type === 'mousedown' ? e : e.touches[0]

      this.firstX = target.clientX
      this.firstY = target.clientY

      if (this.scale > 1) {
        this.isDragging = true
      }
    },

    rightClickBlock (e) {
      console.log('Right Click Block')
      e.preventDefault()
    },

    handleDragging (e) {
      if (!this.isDragging) return

      const { clientX: currX, clientY: currY } = e.type === 'mousemove' ? e : e.touches[0]

      const moveX = currX - this.firstX
      const moveY = currY - this.firstY

      this.firstX = currX
      this.firstY = currY

      const alreadyMoveX = this.interactX * this.scale
      const alreadyMoveY = this.interactY * this.scale

      const totalX = alreadyMoveX + moveX
      const totalY = alreadyMoveY + moveY

      const { limitWidth, limitHeight } = this.imagePositionLimit

      if (Math.abs(totalX) <= limitWidth) {
        this.interactX = totalX / this.scale
      }

      if (Math.abs(totalY) <= limitHeight) {
        this.interactY = totalY / this.scale
      }
    },

    setScale (n = 1) {
      const originalScale = this.scale

      const expectResult = this.scale * n
      const newScale = expectResult > this.maxScale
        ? this.maxScale
        : expectResult < this.minScale
          ? this.minScale
          : expectResult

      if (originalScale === expectResult) return

      gaEvents.sendEvent('Marker', 'ZoomByButton', this.markerInfoData.objectId)

      const isZoomOut = newScale < originalScale

      this.scale = newScale

      this.$nextTick(() => {
        const { width, height } = this.$refs.gallery.getBoundingClientRect()
        this.imageInfo = { ...this.imageInfo, width, height }

        // handle translateXY is over the limitWidth/Height when zoom out
        if (isZoomOut && this.scale > 1) {
          const { limitWidth, limitHeight } = this.imagePositionLimit

          const alreadyMoveX = this.interactX * this.scale
          const alreadyMoveY = this.interactY * this.scale

          if (Math.abs(alreadyMoveX) > limitWidth) {
            const isNearLeft = alreadyMoveX > 0
            this.interactX = (isNearLeft ? limitWidth : -limitWidth) / this.scale
          }
          if (Math.abs(alreadyMoveY) > limitHeight) {
            const isNearTop = alreadyMoveY > 0
            this.interactY = (isNearTop ? limitHeight : -limitHeight) / this.scale
          }
        }
      })

      if (expectResult === 1) {
        this.interactX = 0
        this.interactY = 0
      }
    },
    getActionMutate (marker = this.markerInfoData) {
      const actionData = marker.action || ''
      const actionText = marker.actionText
      const actionMultiData = marker.actionMulti || {}
      const regex = /^cus_/
      const isMutate = regex.test(actionData) || actionData === 'joor'
      const isJoorAction = actionData === 'joor'
      const multiLangData = actionMultiData[this.lang] || ''
      if (isJoorAction) {
        return multiLangData.slice(4) || actionText || null
      } else if (isMutate) {
        return (multiLangData || actionData).slice(4) || null
      } else {
        return this.$t(actionData)
      }
    },
    clickTagAction () {
      if (this.isJoorActionTag(this.markerInfoData) && this.isInJoorPlatform) {
        this.addJoorItemProcess(this.markerInfoData)
        return
      }
      const marker = this.markerInfoData
      const actionLink = marker.actionLink
      const actionLinkMulti = marker.actionLinkMulti
      const i18nLink = actionLinkMulti ? actionLinkMulti[this.lang] : ''
      const link = i18nLink || actionLink
      if (marker.actionType === 'iframe' || marker.actionType === 'largerIframe') {
        this.setPopupUrl(link)
        this.setPopupSizeConfig() // Set Defaults
        if (marker.actionType === 'largerIframe') {
          this.setPopupSizeConfig({
            widthPercent: 90,
            fullHeight: true
          })
        }
        this.showPopup()
      } else {
        window.open(link)
      }
      gaEvents.sendEvent('Marker', 'TagAction', this.markerInfoData.objectId)

      const markerName = has(this.markerInfoData, ['nameMulti', this.$i18n.locale])
        ? this.markerInfoData.nameMulti[this.$i18n.locale]
        : this.markerInfoData.name

      const actionText = has(this.markerInfoData, ['actionMulti', this.$i18n.locale])
        ? toString(this.markerInfoData.actionMulti[this.$i18n.locale].replace(/^cus_/, ''))
        : this.markerInfoData.actionText

      const options = {
        type: 'simpletag',
        title_tag: markerName,
        title_cta: actionText,
        url_direction: this.markerInfoData.actionLink
      }
      gaEvents.sendDataLayer('istaging_conversion', options)
    },
    showArView () {
      const currentMarker = this.markerInfoData
      const arViewAction = currentMarker.arView.action
      const arViewSize = currentMarker.arView.size
      const arViewActionTarget = arViewAction.target || 'iframe'
      if (arViewActionTarget === 'iframe') {
        this.setArViewPopupAction(arViewAction)
        this.setArViewPopupSize(arViewSize)
        this.showArViewPopup()
      }
    },
    onGalleryImageLoad (e) {
      if (isMobile() && window.innerWidth < window.innerHeight && e.currentTarget.naturalWidth > e.currentTarget.naturalHeight) {
        this.customGalleryImageMaxWidth = '100%'
      } else {
        this.customGalleryImageMaxWidth = ''
      }
      this.isGalleryImageReady = true

      const { left, top, width, height } = this.$refs.gallery.getBoundingClientRect()
      this.imageInfo = { left, top, originalWidth: width, originalHeight: height }
    },
    // a被除數, b除數
    mathMod (a, b) {
      return (a % b + b) % b
    },
    updatePriceType (event) {
      if (event.target.value) {
        const selectedPriceType = this.availablePriceType.find(priceType => priceType.id === event.target.value)
        this.setCurrentPriceType(selectedPriceType)
      } else {
        this.setCurrentPriceType({})
      }
    },
    async fetchJoorProductProcess () {
      const loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        if (this.isJoorActionTag(this.markerInfoData) && this.markerInfoData.type === 'tag') {
          await this.getProductProcess([this.markerInfoData.customAttribute.joorProductId])
        } else if (this.markerInfoData.type === 'multitag') {
          const multitags = this.markerInfoData.multitagInfo
          const joorProductIds = multitags.reduce((ids, tag) => {
            if (this.isJoorActionTag(tag)) {
              ids.push(tag.customAttribute.joorProductId)
            }
            return ids
          }, [])
          if (joorProductIds.length > 0) {
            await this.getProductProcess(joorProductIds)
          }
        }
        loadingInstance.close()
      } catch (error) {
        console.error(error)
        Message.error(error)
        loadingInstance.close()
      }
    },
    async addJoorItemProcess (markerInfoData) {
      if (!this.currentCollectionName || this.availablePriceType.length < 1) {
        Message.warning(this.$t('productUnavailable'))
        return
      }
      if (!this.currentPriceType.id) {
        Message.warning('The style\'s price type is not provided by the brand')
        return
      }
      const loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await this.addToOrderProcess(markerInfoData)
        Message.success('Add style to cart success!')
        this.notifyAddItemToCartSuccess()
        loadingInstance.close()
      } catch (error) {
        console.error(error)
        Message.error(error)
        loadingInstance.close()
      }
    },
    isJoorActionTag (tag) {
      return tag.action === 'joor' && !!tag.customAttribute && !!tag.customAttribute.joorProductId && !!tag.customAttribute.joorCollectionId
    },
    notifyAddItemToCartSuccess () {
      window.parent.postMessage(
        JSON.stringify({
          error: false,
          success: true,
          message: 'Product Added'
        }),
        '*'
      )
    },
    clearViewIn3DTooltipTimer () {
      clearTimeout(this.viewIn3DTooltipTimer)
      clearTimeout(this.hideViewIn3DTooltipTimer)
      this.viewIn3DTooltipTimer = null
      this.hideViewIn3DTooltipTimer = null
    },
    showViewIn3DTooltip () {
      this.isViewIn3DTooltipVisible = true
      this.clearViewIn3DTooltipTimer()
    },
    hideViewIn3DTooltip () {
      this.isViewIn3DTooltipVisible = false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'
@import '~css/common/br-extends'

$image-mobile-max-height = 300px
$image-pc-size = 322px

.gallery-container {
  overflow: hidden;
  font-size: 0px;
  text-align: center;
}

.scale-btns {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  gap: 16px
  button {
    @extend .br-cta-button
  }
}

.marker-info {
  position: relative
  // margin-top: 20px
  // padding-top: 20px
  height: 100%

  h4 {
    margin-bottom: 20px
  }

  .text-inner {
    overflow-wrap: break-word
  }
}

.marker-info-category {
  margin-bottom: 20px
  text-align: center
}

.marker-info-large-left {
  position: relative
  text-align: center
  display: flex
  justify-content: center
  align-items: center
  flex-shrink: 0
  margin: 20px 0

  .arrow {
    position: absolute
    width: 32px
    height: 32px
    position: absolute
    background-color: rgba(#fff, .7)
    border-radius: 50%
    display: flex
    justify-content: center
    align-items: center
    font-size: 16px
    color: #333
    &:hover {
      background-color: #fff
    }
    &.left {
      left: 12px

      .isif{
        margin-left: -2px
      }
    }
    &.right {
      right: 12px

      .isif{
        margin-right: -2px
      }
    }
  }
  .slider {
    position: absolute
    left: 50%
    bottom: 20px
    transform: translate(-50%, 50%);
  }
  .scale-image {
    width: $image-pc-size
    height: $image-pc-size
    max-width: 100%
    max-height: 100%
  }
  .arview-button {
    right: 60px
    bottom: 15px
    @media (min-width: $response) {
      right: 15px
    }
    @media (max-width: $response-xs) {
      right: 45px
      bottom: 28px
    }
  }
}

.marker-info-large-right {
  overflow-y: auto
  @extend .scrollbar-narrow;

  &::-webkit-scrollbar-thumb {
    visibility: hidden
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      visibility: visible
    }
  }
}

.marker-info-button {
  @extend .br-cta-button
  margin-bottom: 10px
}

.marker-info-image {
  max-width: 100%
  max-height: $image-mobile-max-height
}

.marker-info-text {
  text-align: center
}

.marker-info-desktop {
  display: none
}

.marker-info-mobile {
  display: block
}

$image-height-desktop = 322px
@media (min-width: $response) {
  .marker-info {
    margin-top: 0
  }

  .marker-info-tag {
    display: flex
    flex-direction: column
  }

  .marker-info-large-left {
    order: 1
    margin: 0
    width: $image-pc-size
    height: $image-pc-size

    .slider {
      transform: scale(0.7) rotate(-90deg)
      top: -10px
      left: -50px
    }
  }

  .marker-info-large-right {
    order: 2
    display: flex
    flex-direction: column
    width: 100%
    height: $image-height-desktop
    margin-left: $marker-info-marker-info-large-right-margin

    // &.has-image {
    //   width: "calc(100vw - %s)" % $image-pc-size
    // }
  }

  .marker-info-large-top {
    order: 1
    display: flex
  }

  .marker-info-large-bottom {
    order: 2
    margin-top: 20px
  }

  .marker-info-image {
    order: 1
    max-height: 100%
  }

  .marker-info-name {
    text-align: $marker-info-marker-info-text-align
    order: 2

    span {
      @extends .br-title
    }
  }

  .marker-info-category {
    text-align: $marker-info-marker-info-text-align
    order: 3
  }

  .marker-info-price {
    text-align: $marker-info-marker-info-text-align
    order: 4

    span {
      @extends .br-price
    }
  }

  .marker-info-action {
    text-align: $marker-info-marker-info-text-align
    order: 5
  }

  .marker-info-description {
    width: 100%
    clear: both
    order: 6
    pre {
      @extend .br-description
    }
  }

  .marker-info-button {
    margin-bottom: 20px
  }

  .marker-info-desktop {
    display: block
  }

  .marker-info-mobile {
    display: none
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  @media (min-width: $response) {
    .marker-info-large-right {
      // margin-right: auto
      margin-right: $marker-info-marker-info-large-right-margin
    }

    .marker-info-name,
    .marker-info-price,
    .marker-info-action {
      text-align: $marker-info-marker-info-text-align-rtl
    }
  }
}

.gallery-image {
  max-width: 80%
  max-height: 400px
  @media (max-width: $response) {
    max-width: 100%
    max-height: 60vh
  }
}

.viewer-layer-third-inner {
  .marker-info {
    margin: 0
  }
}

.padding-x-30 {
  padding-left: 30px
  padding-right: 30px
}
</style>
